export enum PreviewType {
    // Meshes
    Sphere,
    Box,
    Torus,
    Cylinder,
    Plane,
    ShaderBall,

    // Particle systems
    DefaultParticleSystem,
    Bubbles,
    Smoke,
    Rain,
    Explosion,
    Fire,

    Custom,

    // Env
    Room,

    // Gaussian Splatting
    Parrot,
    BricksSkull,
    Plants,
}
